import { api } from './client.js';

export const adminApi = {
  listUsers: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`/api/admin/users${qs ? `?${qs}` : ''}`);
  },
  getUser:    (id) => api.get(`/api/admin/users/${id}`),
  inviteUser: (email, isAdmin, orgId) =>
    api.post('/api/admin/users', {
      email,
      orgId: orgId ?? undefined,
      roles: isAdmin ? ['admin'] : ['member'],
    }),
  updateUser: (id, data) => api.put(`/api/admin/users/${id}`, data),
  deleteUser: (id) => api.delete(`/api/admin/users/${id}`),
};
